<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card class="formGroup">
            <keep-alive>
                <Form ref="AddForm" :loading="loading" :data="userDetail" :forms="UserForm" />
            </keep-alive>
             <template slot="footer">
                <b-button variant="primary" @click="saveForm">{{$t('general.save')}}</b-button>
            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'


    let breadCrumb = [ ]
    export default {
        name: 'UserAdd',
        created: async function(){
            await this.$store.dispatch('getUserDetail', {id: this.$route.params.id})
        },
        data: function(){
            return{
                breadCrumb,
                UserForm: Forms.UserEditForm,
            }
        },
        components:{
            BreadCrumb, Form
        },
        computed:{
            loading(){
                return this.$store.getters.getUserLoading
            },
            userDetail(){
                if(Object.keys(this.$store.getters.getUserDetail).length>0){
                    this.breadCrumb = [
                        { label: this.$store.getters.getUserDetail.username+" - "+ 
                            this.$store.getters.getUserDetail.firstname+" "+this.$store.getters.getUserDetail.lastname,
                            url: "/User/"+this.$route.params.id },
                        { label: i18n.t('pages.account.edit'), url: "/User/"+this.$route.params.id+"/Edit" }
                    ]
                    return this.$store.getters.getUserDetail
                }else
                    return {} 
                
            },
        },
        methods:{
          
            saveForm: function(){
                this.$refs.AddForm.$refs.Form.validate().then( async success =>{
                    if(success){
                        let data =  prepareRequestData(this.UserForm, this.$refs.AddForm.formData)
                        data.id =  this.$route.params.id
                        this.$store.dispatch('user_edit', data)
                        if(this.$store.getters.getUserStatus.status == "Success"){
                            await this.$store.dispatch('getUserDetail', {id: this.$route.params.id})
                        }
                    }
                })  
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Users/Edit.vue